import React, { useEffect, useMemo, useState } from "react";
import { all_routes } from "../router/all_routes";
import { categoriesData } from "../../core/data/json/categoriesData";
import { Link, useLocation } from "react-router-dom";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import Table from "../../core/common/dataTable/index";
import CategoriesModal from "./modals/categoriesModal";
import StatusFilterHeader from "../../core/common/commonComponents/StatusFilterHeader";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../core/data/redux/store";
import {exportToCSV,exportToExcel, exportToPDF,} from "../../core/common/GlobalFunctions/exportTableData";
import PageHeader from "../../core/common/commonComponents/PageHeader";
import {deleteCategory,fetchAllCategories,} from "../../core/data/redux/payroll/Accounting/expensesCategories/expensesCategoriesAction";
import DeleteModal1 from "../../core/modals/deleteModal1";
import { message } from "antd";
import { filterData } from "../../core/common/GlobalFunctions/tableFilters";
import { formatDate } from "../../core/utils/configFormatters";
import { useAppConfig } from "../../customhooks/useAppConfig";
import { decryptData } from "../../core/utils/encryptUtils";

const Categories = () => {
  const routes = all_routes;
  const dispatch = useDispatch<AppDispatch>();
  const [selectedStatus, setSelectedStatus] = useState("active");
  const [selectedSort, setSelectedSort] = useState<any>("");
  const [tableKey, setTableKey] = useState(0);
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] =
    useState<boolean>(false);
  const [modalType, setModalType] = useState<"edit" | "create" | "">("");
  const [selectedRowData, setSelectedRowData] = useState<any>(null);
  const { categories } = useSelector(
    (state: any) => state.accounting.expensesCategories
  );

   const encryptedPermissions = localStorage.getItem('currentPermissions');
   const permissions: string[] = Array.isArray(decryptData(encryptedPermissions || '')) ? decryptData(encryptedPermissions || '') : [];


  const canAdd =
    permissions.includes("Add") || permissions.includes("AllowAll");
  const canView =
    permissions.includes("View") || permissions.includes("AllowAll");
  const canEdit =
    permissions.includes("Edit") || permissions.includes("AllowAll");
  const canDelete =
    permissions.includes("Delete") || permissions.includes("AllowAll");
  const canExport =
    permissions.includes("Export") || permissions.includes("AllowAll");

  useEffect(() => {
    dispatch(fetchAllCategories());
  }, [dispatch]);

  const showModal = (type: "edit" | "create") => {
    setModalType(type);
    setIsModalVisible(true);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
    setModalType("");
  };

  const handleDeleteExpenseCategory = async (id: number) => {
    try {
      dispatch(deleteCategory(id))
      .then((res : any) =>{
      if (res.meta.requestStatus === "fulfilled") {
        message.success("Expense Category deleted successfully");
        setTableKey((prevKey) => prevKey + 1);
        setIsDeleteModalVisible(false);
      } else {
        message.warning(res.payload.message);
      }
      })
      
    } catch (error) {
      message.error("Something went wrong");
    }
  };
  const filtereddata = useMemo(() => {
    const filters =
      selectedStatus && selectedStatus !== "All"
        ? { status: selectedStatus }
        : {};
    return filterData(
      categories,
      filters,
      "createdAt",
      "createdAt",
      selectedSort
    );
  }, [categories, selectedStatus, selectedSort]);

  const config = useAppConfig() ?? {};

  const exportCategories = filtereddata.map((item: any) => ({
    ID: item.expenses_categories_id,
    Category: item.category,
    SubCategory: item.subCategory,
    Status: item.status,
    CreatedBy: item.createdBy,
    ModifiedBy: item.modifiedBy,
    CreatedAt: formatDate(item.createdAt, config),
    ModifiedAt: formatDate(item.modifiedAt, config),
  }));

  useEffect(() => {
    setTableKey((prevKey) => prevKey + 1);
  }, [selectedStatus, selectedSort, categories]);
  const columns = [
    {
      title: "Category Name",
      dataIndex: "category",
      sorter: (a: any, b: any) => a.category.length - b.category.length,
    },
    {
      title: "Sub Category",
      dataIndex: "subCategory",
      sorter: (a: any, b: any) => a.subCategory.length - b.subCategory.length,
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text: string, record: any) => (
        <span
          className={`badge ${text === "active" ? "badge-success" : "badge-danger"
            } d-inline-flex align-items-center badge-xs`}
        >
          <i className="ti ti-point-filled me-1" />
          {text ? text.charAt(0).toUpperCase() + text.slice(1) : ""}

        </span>
      ),
    },
    {
      title: "Action",
      dataIndex: "actions",
      render: (text: string, record: any) => (
        <div>
          <div className="action-icon d-inline-flex">
            {/* Edit Button */}
            {canEdit && (
              <button
                className="me-2"
                onClick={() => {
                  showModal("edit");
                  setSelectedRowData(record);
                }}
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Edit"
              >
                <i className="ti ti-edit" />
              </button>
            )}

            {/* Delete Button */}
            {canDelete && (
              <button
                className={`me-2 ${record.status === "inactive" ? "opacity-50 cursor-not-allowed" : ""}`}
                disabled={record.status === "inactive"}
                onClick={() => {
                  if (record.status === "inactive") return;
                  setSelectedRowData(record);
                  setIsDeleteModalVisible(true);
                }}
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title={record.Status === "inactive" ? "Cannot delete inactive record" : "Delete"}
              >
                <i className="ti ti-trash" />
              </button>
            )}
          </div>
        </div>
      ),
    },
  ];
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <PageHeader
            title="Categories"
            breadcrumbs={[
              {
                label: <i className="ti ti-smart-home" />,
                path: all_routes.adminDashboard,
              },
              { label: "Accounting" },
              { label: "Category", isActive: true },
            ]}
            // listViewPath={all_routes.clientlist}
            listViewPath="#"
            onExportCSV={canExport ? () =>exportToCSV(exportCategories, "expense_category_data") : undefined}
            onExportExcel={canExport ? () =>exportToExcel(exportCategories, "expense_category_data") : undefined}
            onExportPDF={canExport ? () =>exportToPDF(exportCategories, "expense_category_data") : undefined}
            onAdd={canAdd ? () => showModal("create") : undefined}
            addLabel="Add  Category"
            exportEnabled={canExport}
            addButtonEnabled={canAdd}
            rightExtra={<CollapseHeader />}
          />

          {/* /Breadcrumb */}
          {/* Categories Table */}
          <div className="card">
            <StatusFilterHeader
              title="Category List"
              selectedStatus={selectedStatus}
              setSelectedStatus={setSelectedStatus}
              selectedSort={selectedSort}
              setSelectedSort={setSelectedSort}
            />
            <div className="card-body p-0">
              <Table
                key={tableKey}
                dataSource={filtereddata}
                columns={columns}
                Selection={false}
              />
            </div>
          </div>
          {/* /Categories Table */}
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2024 - 2025© hrmtree.</p>
          <p>
            Developed By{" "}
            <Link to="#" className="text-primary">
              Leadchain Systems
            </Link>
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}
      <CategoriesModal
        modalType={modalType}
        handleCancel={handleCancel}
        isModalVisible={isModalVisible}
        selectedRowData={selectedRowData}
      />
      <DeleteModal1
        isVisible={isDeleteModalVisible}
        onClose={() => setIsDeleteModalVisible(false)}
        onConfirm={() =>
          selectedRowData?.expenses_categories_id &&
          handleDeleteExpenseCategory(selectedRowData.expenses_categories_id)
        }
      />
    </>
  );
};

export default Categories;
